import { Injectable, signal } from '@angular/core';

@Injectable()
export class ReferralPageService {
    constructor() {}

    // Create a private writable signal
    private _editMode = signal<boolean>(false);
    private _workflowStatus = signal<Core.LitigationReferralWorkflowStatusModel>(null);

    // Expose it as a read-only signal for components
    readonly editMode = this._editMode.asReadonly();
    readonly workflowStatus = this._workflowStatus.asReadonly();

    updateEditMode(newValue: boolean) {
        this._editMode.set(newValue);
    }

    updateWorkflowStatus(newValue: Core.LitigationReferralWorkflowStatusModel) {
        this._workflowStatus.set(newValue);
    }
}
